import { PlanCategory } from '@/shared/types/Billing';

export type PricingCardFeatureItem = {
  label: string;
};

type PricingCardFeature = {
  // Short marketing description shown under the plan name.
  description: string;
  features: PricingCardFeatureItem[];
};

const text = (label: string): PricingCardFeatureItem => ({ label });

export const PRICING_CARD_FEATURES: Record<PlanCategory, PricingCardFeature> = {
  business: {
    description: 'For teams with a growing video library',
    features: [
      text('Review and manage projects with your team'),
      text('Keep brand and terminology consistent'),
      text('Upload and translate batches of video'),
    ],
  },
  creator: {
    description: 'For trying Rask on smaller projects',
    features: [
      text('Zero-setup onboarding'),
      text('Translate single video into a few languages'),
      text('Upgrade when localization becomes regular'),
    ],
  },
  creator_pro: {
    description: 'For repeat video publishing',
    features: [
      text('Control accuracy of translation and speech'),
      text('Preserve speaker identity with lip-sync'),
      text('Built for recurring projects with a small team'),
    ],
  },
  enterprise: {
    description: 'For global scale requiring trust and predictability',
    features: [
      text('Security and compliance readiness'),
      text('Production Reliability + SLA'),
      text('Custom integrations + API'),
      text('Managed quality assurance'),
    ],
  },
  starter: {
    description: '',
    features: [],
  },
};
